<template>
  <div class="issue-report">
    <v-dialog
      v-model="show"
      max-width="566px"
      persistent
    >
      <v-card>
        <v-card-title
          class="issue-report__title"
          primary-title
        >
          {{ header }}
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pb-1">
          <v-form ref="issueForm" v-model="isFormValid" @submit.prevent="submit">
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  v-model="title"
                  class="form-field"
                  :rules="[rules.required]"
                  dense
                  label="Title*"
                  placeholder="Enter your title"
                />
                <v-textarea
                  v-model="content"
                  :rules="[rules.required]"
                  label="Description*"
                  placeholder="Type your message here…"
                  class="issue-report__textarea mt-3"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="issue-report__actions">
          <v-btn
            color="blue"
            dark
            large
            min-width="256px"
            :loading="isSubmitProcessing"
            @click="submit"
          >
            SEND REPORT
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import validationRules from '@/helpers/validators';

const rules = validationRules;

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    contract: {
      type: [Number, String],
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      rules,
      isFormValid: true,
      title: '',
      content: '',
    };
  },

  computed: {
    ...mapState('issue', [
      'isSubmitProcessing',
    ]),

    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    ...mapActions('issue', [
      'createIssue',
    ]),

    closeModal() {
      this.$emit('input', false);
    },

    submit() {
      this.$refs.issueForm.validate();

      if (this.isFormValid) {
        const issueData = {
          contract_id: this.contract,
          title: this.title,
          content: this.content,
        };
        this.createIssue(issueData)
          .then(() => {
            this.closeModal();
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.issue-report {
  &__title {
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }
  &__actions {
    padding: 0 24px 24px 24px;
    justify-content: flex-end;
  }
  &__textarea fieldset {
    border: 1px solid #E2E6EA !important;
  }
  &__textarea textarea {
    font-weight: 500;
    font-size: 14px;
  }
  &__textarea textarea::placeholder {
    font-weight: 400;
  }
  &__textarea::v-deep  {
    .v-input__slot {
      border: 1px solid #E2E6EA;
      border-radius: 4px;
      padding-top: 20px;
      padding-bottom: 0px;
      padding-left: 16px;
      font-size: 14px;
      min-height: 54px;
      height: auto;
      background-color: white;
    }
    textarea {
      padding-right: 16px;
    }
    .v-input__slot:before {
      border: none;
    }
  }
}
</style>
